import { create } from "zustand";

/**
 * Thin module-level store for the consumer Messages badge (messaging-inbox
 * IA WS6) — the header speech-bubble icon AND the sidebar "Messages" item
 * read the same count. Mirrors the plan-287 notifications store exactly:
 *
 * unreadCount: null = not yet fetched (badge hidden)
 * unreadCount: 0    = fetched, nothing unread (badge hidden)
 * unreadCount: n    = n conversations with unread messages (badge shows n)
 *
 * Seeded app-wide by DashboardBadgeSync from
 * GET /api/consumer/threads/unread-count; re-synced by the thread surfaces
 * (list load, mark-read on thread open) so the badge decrements as
 * conversations are actually read — never cleared wholesale by merely
 * visiting the list.
 */
interface MessagesState {
  unreadCount: number | null;
  setUnreadCount: (count: number) => void;
}

export const useMessagesStore = create<MessagesState>((set) => ({
  unreadCount: null,
  setUnreadCount: (count) => set({ unreadCount: count }),
}));
